module.exports = __webpack_public_path__ + "static/media/vegitables_68.0ff9b258.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_68.csv
// module id = 655
// module chunks = 0